import { httpCreate } from './http';

const http = httpCreate('/shop/api/product-guide');

export const productGuide = {
	getListByPage(activityId, params) {
		return http.get(`/page/${activityId}`, { params });
	},
	getList(activityId, params) {
		return http.get(`/list/${activityId}`, { params });
	},
};
